<template>
  <div class="overlay-gallery">
    <div class="overall-bottom-gradient" @click="$emit('showVideo')"></div>
    <v-container grid-list-md text-xs-center>
      <v-layout row wrap>
        <v-flex xs12>
          <v-container>
            <v-layout row justify-center>
              <v-flex xs12 md8>
                <v-card dark color="black" height="70vmin">
                  <video width="100%" height="100%" controls autoplay
                    v-if="videos.length > 0 && !videos[activeVideo].is_youtube_link"
                    :src="'https://cdnblobendpoint.azureedge.net/bezzina-static/video/' + videos[activeVideo].video"
                  >
                    <!-- <source
                    :type="videos[activeVideo].type"
                    > -->
                    HTML5 video not supported by this browser
                  </video>
                  <iframe v-else width="100%" height="100%" :src="videos[activeVideo].youtube_link" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
                  <div class="input-box">
                    <input id="hidden-input" @keyup.right="handleKeyUp($event)" @keyup.left="handleKeyUp($event)" @blur="handleBlurEvent()" v-focus/>
                  </div>
                  <!-- <p class="img-project-title">{{ images[activeVideo].project }} - {{ images[activeVideo].project_details }}</p> -->
                  <v-icon id="slide-left" large @click="handleLeftClick()">fa fa-angle-left</v-icon>
                  <v-icon id="slide-right" large @click="handleRightClick()">fa fa-angle-right</v-icon>
                </v-card>
              </v-flex>
            </v-layout>
            <v-icon id="close-slide" large @click="$emit('showVideo')" color="white">highlight_off</v-icon>
          </v-container>
        </v-flex>
      </v-layout>
      <p style="color: white;"><span>{{ activeVideo + 1 }}</span>/<span>{{ videos.length }}</span></p>
      <v-layout row wrap id="thumbnail-div" justify-center style="position:relative;">
        <v-icon id="page-slide-left" large @click="pageDown()" color="white" class="hidden-sm-and-down">fa fa-angle-left</v-icon>
        <v-icon id="page-slide-right" large @click="pageUp()" color="white" class="hidden-sm-and-down">fa fa-angle-right</v-icon>
        <div v-for="(item, index) in getVideosPerPage" :key="index" class="hidden-sm-and-down gallery-thumbnail" @click="showVideo(index)">
          <img :src="'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + item.thumbnail"/>
          <div id="overlay" v-if="showOpacity(index)"></div>
        </div>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  props: {
    videos: {
      type: Array,
      default: () => { return [] },
      required: true
    },
    activeIndex: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      activeVideo: this.activeIndex,
      videosPerPage: 5,
      page: 1
    }
  },
  computed: {
    getVideosPerPage: function () {
      return this.videos.slice(((this.page - 1) * this.videosPerPage), (this.videosPerPage * this.page))
    }
  },
  methods: {
    showVideo (index) {
      if (this.page === 1) {
        this.activeVideo = index
      } else {
        this.activeVideo = this.videosPerPage * (this.page - 1) + index
      }
    },
    showOpacity (index) {
      if (this.page === 1) {
        if (this.activeVideo === index) {
          return true
        }
        return false
      } else {
        if (this.activeVideo === this.videosPerPage * (this.page - 1) + index) {
          return true
        }
        return false
      }
    },
    handleKeyUp (e) {
      if (e.key === 'ArrowRight') {
        this.handleRightClick()
      } else if (e.key === 'ArrowLeft') {
        this.handleLeftClick()
      }
      // const activeDiv = this.$el.querySelector('#' + this.activeVideo)
    },
    handleRightClick () {
      if (this.activeVideo === this.videos.length - 1) {
        this.page = 1
        this.activeVideo = 0
      } else if (this.activeVideo === (this.videosPerPage * this.page) - 1) {
        this.activeVideo += 1
        this.page += 1
      } else {
        this.activeVideo += 1
      }
    },
    handleLeftClick () {
      if (this.activeVideo === 0) {
        this.activeVideo = this.videos.length - 1
        this.page = Math.round(this.videos.length / this.videosPerPage)
      } else if (this.activeVideo === (this.page - 1) * this.videosPerPage) {
        this.activeVideo -= 1
        this.page -= 1
      } else {
        this.activeVideo -= 1
      }
    },
    handleBlurEvent () {
      let inputBox = this.$el.querySelector('#hidden-input')
      setTimeout(function () {
        inputBox.focus()
      }, 10)
    },
    pageUp () {
      if (this.page === Math.ceil(this.videos.length / this.videosPerPage)) {
        this.page = 1
        this.activeVideo = 0
      } else {
        this.activeVideo = this.page * this.videosPerPage
        this.page += 1
      }
    },
    pageDown () {
      if (this.page !== 1) {
        this.page -= 1
        this.activeVideo = this.page * this.videosPerPage - this.videosPerPage
      } else {
        this.page = Math.ceil(this.videos.length / this.videosPerPage)
        this.activeVideo = this.page * this.videosPerPage - this.videosPerPage
      }
    }
  }
}
</script>

<style scoped>
.overlay-gallery {
  position: fixed;
  padding: 0;
  margin: 0;

  top: 0;
  left: 0;

  /*display: block;*/
  width: 100%;
  height: 108%;
  background: rgba(0, 0, 0, 0.9);
  /*margin: 0 auto;*/
  text-align: center;
  z-index: 99;
}

.input-box {
  width: 0;
  overflow: hidden;
}
#hidden-input {
  margin: 0 auto;
  width: 100%;
}
.img-project-title {
  position: absolute;
  bottom: 1vh;
  left: 1vw;
  font-size: 1.5vw;
}
.left-bottom-gradient {
  z-index: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  /*left: -10px;*/
  opacity: 0.9;
  /*background-image: radial-gradient(circle farthest-corner at center, #15497E 0%, #3D93BC 100%);*/
  background-image: radial-gradient(at bottom left, rgba(0,0,0,0.8), rgba(0,0,0,0.1), rgba(255,255,255,0));
}
.overall-bottom-gradient {
  width: 100%;
  height: 100%;
  position: absolute;
}
.gallery-thumbnail {
  width: 6.5vmax;
  height: 6.5vmax;
  background: black;
  margin: 2px 5px;
  border-radius: 5px;
  /*margin: 0 auto;*/
}
.gallery-thumbnail img {
  border-radius: 5px;
  /*min-height: 100%;*/
  width: 6.5vmax;
  height: 6.5vmax;
  /*max-width: 100%;*/
}
.gallery-thumbnail {
  position: relative;
}
#overlay {
  background: white;
  opacity: 0.5;
  width: 6.5vmax;
  height: 6.5vmax;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 5px;
}

#slide-left {
  position: absolute;
  left: 0;
  top: 48%;
  width: 5vw;
  height: 5vw;
  border-radius: 25px;
}

#slide-right {
  position: absolute;
  right: 0;
  top: 48%;
  width: 5vw;
  height: 5vw;
}

#page-slide-left {
  position: absolute;
  left: -3.5vmax;
  /*top: 48%;*/
  width: 5vw;
  height: 5vw;
  border-radius: 25px;
}

#page-slide-right {
  position: absolute;
  right: -3.5vmax;
  /*top: 48%;*/
  width: 5vw;
  height: 5vw;
}

#close-slide {
  position: absolute;
  right: 1.5vmax;
  top: 0.5vmax;
  width: 5vw;
  height: 5vw;
}

#thumbnail-div {
  margin-top: 2vh;
}
@media screen and (min-width: 1367px) {
  #thumbnail-div {
    margin: 0 21vw;
  }
}

@media screen and (max-width: 1366px) and (min-width: 1280px) {
  #thumbnail-div {
    margin: 0 10vw;
  }
}

@media screen and (max-width: 1279px) {
  #thumbnail-div {
    margin: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/BuzzTube.vue